import i18n from "i18next";

const formatDateToYYYYMMDD = (date) => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default formatDateToYYYYMMDD;

/**
 * Notification timestamp: the localized "Today" for today, otherwise
 * DD/MM/YYYY like every other date in the system (both languages).
 */
export function formatNotificationDate(dateString) {
  const notificationDate = new Date(dateString);
  if (Number.isNaN(notificationDate.getTime())) return "";
  const now = new Date();

  const isToday =
    notificationDate.getDate() === now.getDate() &&
    notificationDate.getMonth() === now.getMonth() &&
    notificationDate.getFullYear() === now.getFullYear();

  if (isToday) {
    return i18n.t("notifications-ui:today", { defaultValue: "Today" });
  }

  return formatDateToDDMYY(notificationDate);
}

export function formatDateToDDMYY(date) {
  if (!date) return null;

  const parsedDate = new Date(date);

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const day = String(parsedDate.getDate()).padStart(2, "0");

  return `${day}/${month}/${year}`;
}

/**
 * Any date the API hands us, as DD/MM/YYYY (slash, zero-padded, both
 * languages). Accepts a Date, an ISO string, or an already day-first
 * "D/M/YYYY" / "D.M.YYYY" string (what several list endpoints return).
 * Returns `fallback` for empty or unparseable input.
 */
export function formatDisplayDate(value, fallback = "-") {
  if (!value) return fallback;
  if (typeof value === "string") {
    const dayFirst = value.trim().match(/^(\d{1,2})[/.](\d{1,2})[/.](\d{4})$/);
    if (dayFirst) {
      const [, d, m, y] = dayFirst;
      return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
    }
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return fallback;
  return formatDateToDDMYY(parsed);
}
